/**
 * Quick log on the web (core quicklog.ts): which buttons show, the pair's next step, and the Undo window. Pure, so the
 * strip on For You and the shop tablet read the same rules (apps/web/test/quicklog.test.ts).
 */
import type { QuickButtonView } from "../api.ts";
import { isoToLocalTime } from "./time.ts";

/** How many buttons the strip shows. */
export const TOP_BUTTONS = 6;

/**
 * The strip's buttons: a just-logged pair's step 2 first (from the tap's answer), then the catalog's order (the
 * person's own taps first), at most `n`. A button never shows twice.
 */
export function stripButtons(buttons: QuickButtonView[], next?: QuickButtonView, n = TOP_BUTTONS): QuickButtonView[] {
  const list = next ? [next, ...buttons.filter((b) => b.actionId !== next.actionId)] : buttons;
  return list.slice(0, n);
}

/** "Which trash?" only when there's more than one; with one, the tap logs it. */
export const needsPicker = (b: Pick<QuickButtonView, "objects">) => b.objects.length > 1;

/** The question over the picker: "Which trash?", "Which tables?". */
export function pickerTitle(b: Pick<QuickButtonView, "label">): string {
  const noun = b.label.replace(/^[A-Z][a-z]+( out| up)? (the )?/, "");
  return `Which ${noun}?`;
}

/** Undo is still offered: before `undoUntil` (the tap's answer, 30 s after it). */
export const undoOpen = (undoUntil: string, now = Date.now()) => now < Date.parse(undoUntil);

/** The toast: "Logged 2:14 PM ✓". */
export const loggedLine = (at: string, tz?: string) => `Logged ${isoToLocalTime(at, tz)} ✓`;
